/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Engineering_Technology26Inputs */

const en__field_enum_icsrm_engineering_technology26 = /** @type {(inputs: _Field_Enum_Icsrm_Engineering_Technology26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering & Technology`)
};

const de__field_enum_icsrm_engineering_technology26 = /** @type {(inputs: _Field_Enum_Icsrm_Engineering_Technology26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingenieurwesen & Technologie`)
};

/**
* | output |
* | --- |
* | "Engineering & Technology" |
*
* @param {_Field_Enum_Icsrm_Engineering_Technology26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_engineering_technology26 = /** @type {((inputs?: _Field_Enum_Icsrm_Engineering_Technology26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Engineering_Technology26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_engineering_technology26(inputs)
	return de__field_enum_icsrm_engineering_technology26(inputs)
});
export { _field_enum_icsrm_engineering_technology26 as "_field_enum_ICSRM_ENGINEERING_TECHNOLOGY" }